import { render } from "./ClientPersonalNuevo.vue?vue&type=template&id=58590948"
import script from "./ClientPersonalNuevo.vue?vue&type=script&lang=js"
export * from "./ClientPersonalNuevo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__